import React, { useEffect, useRef, useState } from "react";
import "./Header.scss";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../../app/slice/authSlice";
import { Link, useNavigate } from "react-router-dom";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { HeaderMenu } from "../menu/Headermenu";
import MenuDropdown from "../../../components/ui/Menudropdown/MenuDropdown";
import Iconify from "../iconify/iconify";
import { FullScreenToggle } from "../../../lib/fullScreenToggle";
import Avatar from "../../../components/ui/avatar/Avtar";
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";
import CreateTask from "../../../pages/task/CreateTask";
import Buttons from "../../../components/ui/button/Buttons";
import { DropdownWrapper } from "../../../components/ui/dropdownwrapper/DropdownWrapper";
import Tooltip from "../../../components/ui/tooltip/Tooltip";
import HeaderTimesheetPanel from "./features/headerTimesheetPanel/HeaderTimesheetPanel";

const Header = ({ onModelOpen, toggleSidebarCollapsed }) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  const [isAdmin, setIsAdmin] = useState(false);
  const [profile, setProfile] = useState(null);
  const [userName, setUserName] = useState("user");
  const [isNavbarToggled] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [currentMenuItems, setCurrentMenuItems] = useState([]);
  const dropdownRef = useRef(null);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [taskTypeId, setTaskTypeId] = useState(null);

  useEffect(() => {
    if (user) {
      setIsAdmin(user.isSupperAdmin);
      setProfile(`data:image/png;base64,${user.profilePicBase64}`);
      setUserName(user.userName);
    }
  }, [user]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setTimeout(() => {
          handleMenuClose();
        }, 100);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const handleLogout = () => {
    dispatch(logout());
  };

  const handleMenuClick = (event, menuItem) => {
    if (menuItem.children) {
      event.preventDefault();
      if (anchorEl && anchorEl === event.currentTarget) {
        setAnchorEl(null);
        setCurrentMenuItems([]);
      } else {
        setAnchorEl(event.currentTarget);
        setCurrentMenuItems(menuItem.children);
      }
    } else {
      setAnchorEl(null);
      setCurrentMenuItems([]);
    }
  };

  const handleToggleModal = () => {
    setShowModal(false);
    setTaskTypeId(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setCurrentMenuItems([]);
  };

  const handleFullScreenToggle = () => {
    let IsFullScreen = FullScreenToggle();
    setIsFullScreen(IsFullScreen);
  };

  const openAdmin = () => {
    navigate("/admin/Organization");
  };

  const openProfileSettings = () => {
    navigate("/profileSettings");
  };

  const handleTaskModal = (typeId) => {
    setTaskTypeId(typeId);
    setShowModal(true);
  };

  return (
    <div className={`header ${isNavbarToggled ? "toggled" : ""}`}>
      {/* Mobile/Tablet Sidebar Toggle Burger Button */}
      <div className="sidebar-toggle-btn-mobile" onClick={toggleSidebarCollapsed}>
        <Iconify icon="iconamoon:menu-burger-horizontal-fill" />
      </div>
      {/* Header Menu Items */}
      <div className="header-menu">
        <ul className="header-menu-list">
          {HeaderMenu.map((menuItem) => (
            <li key={menuItem.menuKey} className="header-menu-item">
              <Link
                to={menuItem.navigationPath}
                onClick={(event) => handleMenuClick(event, menuItem)}
              >
                {/* <Image imagePath={menuItem.menuIcon} /> */}
                <span>{menuItem.menuTitle}</span>
                {menuItem.children && <ArrowDropDownIcon />}
              </Link>
            </li>
          ))}
        </ul>

        <MenuDropdown
          isAdmin={isAdmin}
          onModelOpen={onModelOpen}
          anchorEl={anchorEl}
          menuItems={currentMenuItems}
          onClose={handleMenuClose}
          ref={dropdownRef}
        />
        <Buttons
          textWithIcon={true}
          fontIcon={true}
          iconName="material-symbols:add-rounded"
          buttonTypeClassName="add-task-btn theme-btn"
          buttonText="Task"
          onClick={() => handleTaskModal(1)}
        >
          Create Task
        </Buttons>
        <Buttons
          textWithIcon={true}
          fontIcon={true}
          iconName="material-symbols:add-rounded"
          buttonTypeClassName="bug-btn ml-3"
          buttonText="Bug"
          onClick={() => handleTaskModal(2)}
        >
          Create Bug
        </Buttons>

        {showModal && (
          <SidebarModel
            isOpen={showModal}
            onClose={handleToggleModal}
            modalTitle="Create Task"
            modalSize="w-50"
            backdropClosable={false}
          >
            <CreateTask projectId={0} typeId={taskTypeId} onClose={handleToggleModal} />
          </SidebarModel>
        )}
      </div>
      {/* End of Header Menu Items */}
      {/* <div className="header-search"><SearchBar /></div> */}
      <div className="right-section">
        <div className="profile-section">
          {isAdmin && (
            <div className={`shortcut-sec`}>
              <div
                id="header-admin-action"
                className="shortcut-icon header-icon-part"
                onClick={() => openAdmin()}
              >
                <Iconify icon="clarity:administrator-line" />
              </div>
              <Tooltip
                label="Admin"
                targetId="header-admin-action"
                position="bottom"
                delayShow={200}
              />
            </div>
          )}
          <HeaderTimesheetPanel />
          <div
            id="header-fullscreen-action"
            className="fullscreen header-icon-part"
            onClick={handleFullScreenToggle}
          >
            <Iconify
              icon={
                isFullScreen
                  ? "bytesize:fullscreen-exit"
                  : "bytesize:fullscreen"
              }
            />
          </div>
          <Tooltip
            label={isFullScreen ? "Exit Fullscreen" : "Fullscreen"}
            targetId="header-fullscreen-action"
            position="bottom"
            delayShow={200}
          />

          <div className="profiles">
            <DropdownWrapper
              toggleElement={
                <div className="profile-img">
                  <Avatar
                    alt={userName}
                    size="small"
                    shape="circle"
                    tooltip={false}
                  />
                </div>
              }
              className="profiles"
            >
              <div className="profile-dropdown-menu">
                <div className="title-list profile-title">
                  <div className="user-icon">
                    <Avatar
                      src={profile}
                      alt={userName}
                      size="small"
                      shape="circle"
                      // tooltip={false}
                    />
                  </div>
                  <div className="dropdown-user-info">
                    <span className="name-title ">Signed in as</span>
                    <span className="user-name">{userName}</span>
                  </div>
                </div>
                <div className="title-list drop-down-icon-menu">
                  <button
                    className="account-settings-btn"
                    onClick={openProfileSettings}
                  >
                    <Iconify icon="marketeq:settings" />
                    <div className="btn-title">Profile Settings</div>
                  </button>
                </div>
                <div className="title-list drop-down-icon-menu">
                  <a href="#" onClick={handleLogout} className="logout-text">
                    <span className="bi bi-box-arrow-left">Log out</span>
                  </a>
                </div>
              </div>
            </DropdownWrapper>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
